import client from './client';

// ============================================
// 2026-10-19（M1）：导入配额/审计（服务端权威；前端仅展示与提示）
// ============================================

export interface ImportPolicyInfo {
  tier: 'free' | 'paid' | 'superadmin';
  maxFiles: number;
  maxTotalMB: number;
  maxFileMB: number;
  usedFiles: number;
  usedBytes: number;
  remainingFiles: number;
  remainingBytes: number;
  storageBonusGB: number;
}

export interface ImportLogItem {
  id: string;
  source: 'model' | 'texture' | 'envmap';
  sceneId: string;
  fileName: string;
  fileSize: number;
  sha256: string;
  ext: string;
  url: string;
  rightsDeclared: boolean;
  ip: string;
  removedAt: string | null;
  createdAt: string;
}

/** 当前用户导入配额（含占用） */
export async function fetchImportPolicy(): Promise<ImportPolicyInfo> {
  const { data } = await client.get('/imports/policy');
  return data;
}

/** 我的导入记录（审计自查，最新在前） */
export async function fetchImportLogs(limit = 50): Promise<ImportLogItem[]> {
  const { data } = await client.get(`/imports/logs?limit=${limit}`);
  return data;
}

/** 容量友好显示（MB/GB） */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 MB';
  const mb = bytes / (1024 * 1024);
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} GB` : `${mb.toFixed(1)} MB`;
}
